exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-item-group>.v-size--small[data-v-151cddbc]{margin-top:35px!important}", ""]);

// exports
